module.exports = __webpack_public_path__ + "05c65a62d64580653ac6f64153f80a60.svg";